///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class LinksColors {
    public static readonly selected = '#49e260';
    public static readonly frozen = '#693dff';
    public static readonly installed = '#007b10';
    public static readonly disabled = '#969696';
    public static readonly link = '#4a90e2';
    public static readonly notConfirmedLOS = '#90aed6';
    public static readonly confirmedLOS = '#4a90e2';
    public static readonly noLOS = '#a4c7f0';
    public static readonly fiber = '#f06de8';
}
